import { motion } from "motion/react";
import { useTheme } from "@mui/material";

export const FourDPLogoWithCopySvg = ({
  activeStep,
  stepId,
}: {
  activeStep: number;
  stepId: number;
}) => {
  const theme = useTheme();

  if (activeStep !== stepId) return null;

  return (
    <motion.svg
      width="361"
      height="284"
      viewBox="0 0 284 284"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4959_3997)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.77 6.81591C128.023 0.853555 150.897 14.0589 156.86 36.311C162.823 58.5633 149.616 81.4364 127.363 87.3989C100.478 94.6026 83.3367 120.02 85.6608 146.818C76.308 129.28 55.8063 119.837 35.7838 125.202C17.7642 130.03 5.40467 145.439 3.60024 162.953C-7.02396 93.3693 36.1933 25.4581 105.77 6.81591Z"
          fill="url(#paint0_linear_4959_3997)"
        />
        <path
          d="M121.019 3.61051C190.601 -7.04867 258.526 36.1539 277.168 105.722C283.128 127.965 269.927 150.827 247.684 156.787C225.44 162.747 202.576 149.547 196.615 127.305C189.419 100.45 164.041 83.3215 137.272 85.6164C154.748 76.2399 164.146 55.7786 158.791 35.7941C153.961 17.7682 138.542 5.40734 121.019 3.61051Z"
          fill="url(#paint1_linear_4959_3997)"
        />
        <path
          d="M280.376 120.937C291.087 190.547 247.875 258.521 178.274 277.169C156.03 283.129 133.166 269.93 127.206 247.687C121.245 225.444 134.446 202.581 156.69 196.621C183.477 189.443 200.587 164.177 198.397 137.487C199.784 140.114 201.639 143.019 204.085 145.84C211.797 154.732 225.289 162.673 248.113 158.739L248.158 158.731L248.202 158.719C266.23 153.889 278.59 138.463 280.376 120.937Z"
          fill="url(#paint2_linear_4959_3997)"
        />
        <path
          d="M36.3037 127.213C58.5476 121.253 81.4118 134.453 87.372 156.696C94.5792 183.592 120.024 200.731 146.837 198.373C129.334 207.733 119.915 228.208 125.273 248.205C130.104 266.231 145.529 278.589 163.054 280.377C93.4418 291.085 25.4685 247.875 6.81931 178.279C0.859081 156.036 14.0597 133.173 36.3037 127.213Z"
          fill="url(#paint3_linear_4959_3997)"
        />
        <path
          opacity="0.8"
          d="M202.122 72.7092L201.121 71.6221L212.577 66.8867L213.562 67.957L207.893 78.9806L206.893 77.8936L208.525 74.8008L205.339 71.339L202.122 72.7092ZM206.559 70.8186L209.145 73.6282L211.746 68.7019L211.684 68.635L206.559 70.8186ZM226.555 90.0819L225.782 88.9034C226.945 87.7338 226.908 86.1008 226.06 84.8083C224.902 83.0405 222.624 82.5499 220.096 84.2068C217.567 85.8638 217.108 88.1484 218.267 89.9162C219.114 91.2087 220.596 91.8948 222.133 91.2954L222.905 92.4739C220.673 93.4209 218.448 92.5966 217.164 90.6388C215.532 88.1487 216.269 85.0846 219.348 83.0663C222.427 81.0481 225.531 81.5956 227.163 84.0857C228.446 86.0435 228.314 88.4127 226.555 90.0819Z"
          fill="black"
        />
        <path
          opacity="0.8"
          d="M65.1981 69.4867L73.5783 77.5599L72.6323 78.542L61.6532 76.7698L61.5744 76.8516L68.1542 83.1904L67.1765 84.2052L58.7963 76.1319L59.7424 75.1499L70.7536 76.9214L70.8324 76.8396L64.2363 70.4851L65.1981 69.4867ZM75.0375 59.7859L76.4062 58.8085L85.2378 64.3709L85.3487 64.2916L82.9535 54.1329L84.3222 53.1555L91.0847 62.6251L90.0119 63.3912L84.874 56.1965L84.7816 56.2626L86.9602 65.5705L85.9245 66.3102L77.8273 61.2288L77.7348 61.2948L82.8727 68.4895L81.8 69.2556L75.0375 59.7859Z"
          fill="black"
        />
        <path
          opacity="0.8"
          d="M177.017 225.609L178.469 224.76L186.761 231.098L186.879 231.029L185.412 220.696L186.864 219.846L192.742 229.889L191.604 230.555L187.138 222.925L187.04 222.982L188.368 232.449L187.269 233.092L179.665 227.299L179.567 227.356L184.033 234.986L182.895 235.652L177.017 225.609ZM204.966 222.071L203.891 223.084L199.017 211.687L200.075 210.689L211.167 216.223L210.092 217.237L206.98 215.642L203.557 218.87L204.966 222.071ZM203.022 217.657L205.8 215.037L200.842 212.496L200.776 212.558L203.022 217.657ZM220.182 207.317L210.965 200.215L213.364 197.1C215.032 194.935 217.065 194.959 218.694 196.215C220.324 197.47 220.883 199.443 219.229 201.59L217.676 203.607L221.042 206.201L220.182 207.317ZM216.685 202.844L218.211 200.863C219.352 199.383 218.956 198.166 217.848 197.313C216.741 196.46 215.482 196.4 214.327 197.899L212.815 199.861L216.685 202.844Z"
          fill="black"
        />
        <path
          opacity="0.8"
          d="M68.3312 201.319L69.2014 200.422L75.4669 206.497L74.5968 207.395L71.9698 204.847L64.7396 212.304L63.728 211.323L70.9582 203.866L68.3312 201.319ZM76.8969 223.702L83.64 214.218L86.8444 216.497C89.0717 218.08 89.1256 220.113 87.9337 221.789C86.7418 223.465 84.7914 224.1 82.5826 222.53L80.5081 221.055L78.0452 224.518L76.8969 223.702ZM81.2324 220.036L83.2699 221.485C84.7933 222.568 85.9938 222.125 86.8038 220.986C87.6138 219.846 87.6249 218.586 86.083 217.489L84.064 216.054L81.2324 220.036Z"
          fill="black"
        />
        <path
          d="M141.148 140.074L137.679 143.756C137.699 144.003 137.709 144.253 137.709 144.506C137.709 145.191 137.634 145.859 137.491 146.502L137.512 147.912C137.522 148.567 137.046 149.111 136.43 149.181C134.832 151.87 131.898 153.673 128.543 153.673C123.48 153.673 119.376 149.569 119.376 144.506C119.376 139.443 123.48 135.339 128.543 135.339C131.088 135.339 133.391 136.377 135.052 138.052L135.083 128.199L142.301 137.044C142.601 137.344 142.72 137.762 142.656 138.155C143.269 137.56 143.967 137.053 144.729 136.652C144.191 136.102 143.751 135.652 143.56 135.46C142.87 134.767 143.663 133.817 143.663 133.817L144.839 132.534H140.443L136.047 128.016H147.342C148.365 128.016 148.979 128.376 149.592 129.504C150.205 130.635 149.285 131.713 149.285 131.713L146.269 134.691L147.265 135.774C147.793 135.677 148.337 135.626 148.893 135.626C153.854 135.626 157.876 139.666 157.876 144.649C157.876 149.633 153.854 153.673 148.893 153.673C143.931 153.673 139.909 149.633 139.909 144.649C139.909 142.979 140.361 141.415 141.148 140.074ZM146.637 138.613C144.206 139.53 142.476 141.887 142.476 144.649C142.476 148.209 145.349 151.095 148.893 151.095C152.436 151.095 155.309 148.209 155.309 144.649C155.309 141.305 152.774 138.556 149.529 138.235L149.965 138.71C149.965 138.71 150.711 139.561 149.796 140.286C149.507 140.514 149.241 140.593 149.014 140.593C148.526 140.593 148.212 140.235 148.212 140.235C148.212 140.235 147.506 139.507 146.637 138.613ZM153.008 130.875C152.464 130.875 151.932 130.678 151.584 130.336L147.9 126.327H153.008C154.226 126.327 155.215 127.348 155.215 128.601C155.215 129.858 154.226 130.875 153.008 130.875ZM128.543 150.923C132.086 150.923 134.959 148.05 134.959 144.506C134.959 140.962 132.086 138.089 128.543 138.089C124.999 138.089 122.126 140.962 122.126 144.506C122.126 148.05 124.999 150.923 128.543 150.923ZM137.333 135.572L137.404 140.439L139.73 137.972L137.333 135.572Z"
          fill={`${theme.palette.text.primary}`}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4959_3997"
          x1="159.551"
          y1="26.1277"
          x2="46.7472"
          y2="143.663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF36A4" />
          <stop offset="1" stopColor="#FFC2E4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4959_3997"
          x1="246.521"
          y1="112.019"
          x2="210.31"
          y2="-14.4538"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8400" />
          <stop offset="1" stopColor="#FFCEA1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4959_3997"
          x1="271.916"
          y1="117.932"
          x2="133.48"
          y2="247.856"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEF39B" />
          <stop offset="1" stopColor="#FECF12" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4959_3997"
          x1="6.29964"
          y1="127.839"
          x2="121.239"
          y2="272.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29D4FF" />
          <stop offset="1" stopColor="#A7EDFF" />
        </linearGradient>
        <clipPath id="clip0_4959_3997">
          <rect width="284" height="284" rx="140" fill="white" />
        </clipPath>
      </defs>
    </motion.svg>
  );
};
